import React from 'react';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "Diesel" or "Electric - Grid"' },
];

const EnergySourceManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Pump Energy Sources"
    icon={<LocalGasStationIcon />}
    apiPath="/api/energy-sources"
    fields={fields}
    entityLabel="Energy Source"
  />
);

export default EnergySourceManagement;
